import Record from './base'

export class EventTicket extends Record {
  constructor(...args) {
    super(...args)
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/eventticket.js